import React, { useContext, useEffect, useState } from 'react';
import { EditCustomerContext, IEditCustomerContext } from '../../../../editCustomerState/editCustomerContext';
import { IStyleContext, StyleContext } from '../styleState/styleContext';
import { TLanguageIDs } from 'types';
import { switchArrayItems } from 'utils/helpers';
import { LanguageBarItemNew } from 'components/LanguageBarItem/LanguageBarItemNew';

export const LanguageBar: React.FC = () => {
	const { setLanguage, mediaSettingsForUpdate, selectedLanguage } = useContext<IStyleContext>(StyleContext);
	const { IDSelectedCustomerDefaultLanguage } = useContext<IEditCustomerContext>(EditCustomerContext);
	const [orderedLanguages, setOrderedLanguages] = useState<TLanguageIDs[]>([]);

	useEffect(() => {
		const availableLanguages = mediaSettingsForUpdate.map((el) => el.languageId);
		const indexOfDefaultLanguage = availableLanguages.findIndex((el) => el === IDSelectedCustomerDefaultLanguage);
		const orderedByDefaultLanguage = switchArrayItems(availableLanguages, indexOfDefaultLanguage, 0);
		setOrderedLanguages(orderedByDefaultLanguage);
	}, [IDSelectedCustomerDefaultLanguage, mediaSettingsForUpdate]);

	useEffect(() => {
		setLanguage(orderedLanguages[0]);
	}, [orderedLanguages.length]);

	return orderedLanguages.length ? (
		<div className="flex flex-wrap gap-4" data-test="LanguageBar">
			{orderedLanguages.map((el) => (
				<LanguageBarItemNew
					key={el}
					languageId={el}
					isActive={selectedLanguage === el}
					onClick={() => setLanguage(el)}
				/>
			))}
		</div>
	) : null;
};
